// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ uploadLimitExceeded: boolean }>;

export const DispatchSetUploadLimitExceeded: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/GreifOrderUpload/SetUploadLimitExceeded",
        parameter: props.parameter,
    });
};

export const chain = [DispatchSetUploadLimitExceeded];

const setUploadLimitExceeded = createHandlerChainRunner(chain, "SetUploadLimitExceeded");
export default setUploadLimitExceeded;
